import script from "./ProjectsFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsFilters.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__